import { render, staticRenderFns } from "./information.vue?vue&type=template&id=6e418460&scoped=true&"
import script from "./information.vue?vue&type=script&lang=js&"
export * from "./information.vue?vue&type=script&lang=js&"
import style1 from "./information.vue?vue&type=style&index=1&id=6e418460&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e418460",
  null
  
)

export default component.exports